import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
export function AppShell() {
    const [colapsado, setColapsado] = useState(false);
    return (_jsxs("div", { className: "flex min-h-screen bg-surface-base", children: [!colapsado ? _jsx(Sidebar, {}) : null, _jsxs("div", { className: "flex min-w-0 flex-1 flex-col", children: [_jsx(Header, { onToggleSidebar: () => setColapsado((c) => !c) }), _jsx("main", { className: "flex-1 p-6 lg:p-8", children: _jsx("div", { className: "mx-auto w-full max-w-[1440px]", children: _jsx(Outlet, {}) }) })] })] }));
}
